import { dateFormat, res } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";

export interface platformStatis {
    sns: number;
    month: number;
    cntBussiness: number;
    cntCondition: number;
    cntTavern: number;
    cntCamouflage: number;
    cntEtc: number;
    cntNone: number;
    cntMonitoring: number;
    cntDel: number;
}

export interface resultCntData {
    idx: number;
    year: number;
    month: number;
    date: number;
    cntResultAll: number;
    cntResultX: number;
    cntResultBluesky: number;
    cntResultGoogle: number;
    cntResultNaver: number;
    cntResultYoutube: number;
    cntResultInstagram: number;
    cntAll: number;
    cntX: number;
    cntBluesky: number;
    cntGoogle: number;
    cntNaver: number;
    cntYoutube: number;
    cntInstagram: number;
    state: number;
    createDate: number;
    updateDate: number;
}

interface DateParam {
    startDate: string;
    endDate: string;
}
interface SearchParam {
    page: number;
    size: number;
    startDate: string;
    endDate: string;
}

export default {
    async monitoring(type: number, date: Array<Date>): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/statistics/monitoring",
                {
                    type,
                    startDate: dateFormat(new Date(date[0])),
                    endDate: dateFormat(new Date(date[1])),
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async graph(snsType: number, date: Array<Date>): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/statistics/graph",
                {
                    snsType,
                    startDate: dateFormat(new Date(date[0])),
                    endDate: dateFormat(new Date(date[1])),
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async resultGraph(param: Array<Date>): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/statistics/result/graph",
                {
                    startDate: dateFormat(new Date(param[0])),
                    endDate: dateFormat(new Date(param[1])),
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getWordcloud(param: DateParam): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/statistics/result/wordCloud", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getResultKeyword(param: SearchParam): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/statistics/result/keyword", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getCoOccurence(param: DateParam): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/statistics/result/cooccurence", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
